import { makeApi } from "@zodios/core";
import { z } from "zod";

import { deliveryPointSearchDtoSchema } from "@/types/backoffice/dto/pdl/delivery-point-search-dto.ts";

export const backofficePdlApi = makeApi([
  {
    method: "put",
    path: "/site/:siteId/manual-validation",
    alias: "updateSiteDeliveryPointValidation",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: z.object({ validationState: z.boolean() }),
      },
    ],
    response: z.any(),
  },
  {
    method: "put",
    path: "/site/:siteId/manual",
    alias: "updateManualSiteDeliveryPoint",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: z.object({ pdl: z.string() }),
      },
    ],
    response: z.any(),
  },
  {
    method: "get",
    path: "/search",
    alias: "searchDeliveryPoint",
    parameters: [
      {
        type: "Query",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Query",
        name: "contractOwner",
        schema: z.string().min(1),
      },
      {
        type: "Query",
        name: "address",
        schema: z.string().min(1),
      },
    ],
    response: z.array(deliveryPointSearchDtoSchema),
  },
  {
    method: "post",
    path: "/site/:siteId",
    alias: "updateSiteDeliveryPointUsingPdlSearch",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
      {
        type: "Body",
        name: "body",
        schema: deliveryPointSearchDtoSchema,
      },
    ],
    response: z.any(),
  },
]);
